import React, { useContext, useRef, useState } from "react";
import Axe from "../../assets/images/x.svg";
import { useReactToPrint } from "react-to-print";
import { notifyError } from "../../toaster/notify";
import { Modal } from "react-bootstrap";
import Logo from '../../assets/images/wifi-attendance.svg'
import { Link } from "react-router-dom";
import { displayDateFormat } from "../../common";
import { AppContext } from "../../context/AppContext";
import close_modal from "../../assets/images/close_modal.svg";
import close_modal_dark from "../../assets/images/close_modal_dark.svg";
import { ToWords } from "to-words";

const ServicePrintPreview = ({
  previewTaxInvoiceData,
  print,
  setPrint,
  printModal,
  setPrintModal,
}) => {
  const { company_details, appSettings, userData } = useContext(AppContext);
  const [typeOfPrint, setTypeOfPrint, units, Dark] = useState([]);
  const getPageMargins = () => {
    return `@page { margin: ${"20px"} ${"20px"} ${"20px"} ${"20px"} !important;} 
        @media print {
          .page-break {
            display: block;
            page-break-after: always;
          }
        }
        } `;
  };

  const container = useRef(null);
  var commaNumber = require("comma-number");
  const toWords = new ToWords();
  const amountInWords = toWords.convert(
    previewTaxInvoiceData && previewTaxInvoiceData.totalAmount
      ? previewTaxInvoiceData.totalAmount
      : 0,
    {
      currency: true,
    }
  );

  const isStateSame =
    previewTaxInvoiceData?.suppGSTNo?.substring(0, 2) ===
      previewTaxInvoiceData?.placeOfSupply?.split("-")[1]
      ? true
      : previewTaxInvoiceData?.placeOfSupply === ""
        ? true
        : false;

  const handlePrint = useReactToPrint({
    contentRef: container
  });
  return (
    <div>
      <Modal
        className="sales-home-modal purchase-view-modal"
        id="print-modal-style"
        size="lg"
        show={printModal}
        onHide={() => setPrintModal(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Body>
          <div className="btnCloseRper">
            <div>
              <Link
                to="#"
                className="text-white"
              //   onClick={() => setIsView(false)}
              >
                <img
                  src={Axe}
                  alt=""
                  className="closeBtn"
                  onClick={() => setPrintModal(false)}
                />
              </Link>
            </div>
            <div>
              <Link
                to="#"
                onClick={() => {
                  handlePrint();
                  setPrintModal(false);
                }}
                className="salesCopyBtn text-white rpsCopyBtn"
              >
                Print
              </Link>
            </div>
          </div>

          <div ref={container}>
            {typeOfPrint.map((type, index) => {
              return (
                <div
                  key={"type" + index}
                  // style={{ visibility: index != 0 && "hidden" }}
                  className="main-invoice-card  page-break"
                >
                  <style>{getPageMargins()}</style>
                  <div
                    className="print-copy-type text-center "
                    style={{
                      // textAlign: "center",
                      marginTop: "-10px",
                      fontSize: "10px",
                    }}
                  >
                    {type}
                  </div>
                  <div
                    className="invoice-inner-main "
                    style={{
                      border: "0.765311px solid #111111",
                      // margin: "0 15px 15px 15px",
                      // marginLeft: "15px",
                      //   marginRight:"15px",
                      // padding:"10px"
                      // margin:"15px"
                    }}
                  >
                    <div
                      className="text-invoice-main"
                      style={{
                        borderBottom: "0.765311px solid #111111 ",
                        // marginBottom:"0"
                      }}
                    >
                      <div className="text-invoice-inner coninversereponsive">
                        <table style={{ width: "100%" }}>
                          <tr>
                            <td style={{ width: "100%" }}>
                              <div className="left">
                                <table>
                                  <tr>
                                    <td>
                                      <div className="text-invoice-heading">
                                        <label htmlFor="">Tax Invoice</label>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div className="invoice-date-number">
                                        <table>
                                          <tr>
                                            <td>
                                              <label htmlFor="">
                                                {
                                                  previewTaxInvoiceData.invoiceNo
                                                }
                                              </label>
                                            </td>
                                            <td>
                                              <label htmlFor="">
                                                Date: &nbsp;
                                                <span>
                                                  {displayDateFormat(
                                                    appSettings.dateFormat,
                                                    previewTaxInvoiceData.invoiceDate
                                                  )}
                                                </span>
                                              </label>
                                            </td>
                                            <td>
                                              <label htmlFor="">
                                                Due Date: &nbsp;
                                                <span>
                                                  {displayDateFormat(
                                                    appSettings.dateFormat,
                                                    previewTaxInvoiceData.dueDate
                                                  )}
                                                </span>
                                              </label>
                                            </td>
                                          </tr>
                                        </table>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </td>
                            <td>
                              {/* <div className="right">
                                          <img src={Logo} alt="" />
                                        </div> */}
                              <div className="right">
                                <img
                                  src={userData?.CompanyLogo}
                                  alt=""
                                  onError={(e) => e.target.src = Logo}
                                />
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div
                      className="name-details-main"
                      style={{
                        borderBottom: "0.765311px solid #111111 ",
                        // padding: " 0 15px",
                      }}
                    >
                      <div
                        className="name-details-inner "
                        style={{ margin: "0" }}
                      >
                        <div className="print-table-outer">
                          <table style={{ width: "100%" }}>
                            <tr>
                              <td
                                style={{ width: "58%" }}
                                valign="top"
                                className="printtable-companyName"
                              >
                                <div className=" left p-0">
                                  <div className="name">
                                    <label htmlFor="">
                                      {previewTaxInvoiceData.suppName}
                                    </label>
                                  </div>
                                  <div className="address">
                                    <div>
                                      <label htmlFor="" id="address">
                                        {previewTaxInvoiceData.suppAddr}
                                      </label>
                                    </div>
                                    <div>
                                      <label
                                        htmlFor=""
                                        className="contact"
                                        style={{ fontSize: "11px" }}
                                      >
                                        Email Id :
                                        <span>
                                          {" "}
                                          {previewTaxInvoiceData.suppEmail}
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label
                                        htmlFor=""
                                        className="contact"
                                        style={{ fontSize: "11px" }}
                                      >
                                        Contact No:
                                        <span>
                                          {" "}
                                          {previewTaxInvoiceData.suppContactNo}
                                        </span>
                                      </label>
                                    </div>
                                    {appSettings &&
                                      appSettings.isGSTApplicable && (
                                        <div>
                                          <label htmlFor="" className="gst-no">
                                            GST No. :
                                            <span>
                                              {" "}
                                              {previewTaxInvoiceData.suppGSTNo}
                                            </span>
                                          </label>
                                        </div>
                                      )}
                                    <div>
                                      <label htmlFor="" className="pan-no">
                                        PAN No. :{" "}
                                        <span>
                                          {previewTaxInvoiceData.suppPANNo}
                                        </span>
                                      </label>
                                    </div>
                                    {previewTaxInvoiceData?.poNo && (
                                      <div>
                                        <label htmlFor="" className="pan-no">
                                          P.O No. :{" "}
                                          <span>
                                            {previewTaxInvoiceData?.poNo}
                                          </span>
                                        </label>
                                      </div>
                                    )}
                                    {previewTaxInvoiceData?.poDate && (
                                      <div>
                                        <label htmlFor="" className="pan-no">
                                          PO Date :{" "}
                                          <span>
                                            {displayDateFormat(
                                              appSettings.dateFormat,
                                              previewTaxInvoiceData?.poDate
                                            )}
                                          </span>
                                        </label>
                                      </div>
                                    )}

                                    {/* <div>
                                                <label
                                                  htmlFor=""
                                                  className="pan-no"
                                                >
                                                  E-way Bill No. :{" "}
                                                  <span>
                                                    {
                                                      previewTaxInvoiceData.ewayBillNo
                                                    }
                                                  </span>
                                                </label>
                                              </div> */}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div
                                  className=" right p-0"
                                  style={{ margin: "-12px 0 0 0" }}
                                >
                                  <div className="place-heading">
                                    <label htmlFor="">Place of Supply:</label>
                                  </div>
                                  <div className="place">
                                    <label htmlFor="">
                                      {previewTaxInvoiceData.placeOfSupply}
                                    </label>
                                  </div>
                                  <div className="place-heading">
                                    <label htmlFor="">Mode of Payment:</label>
                                  </div>
                                  <div className="place">
                                    <div>
                                      {/* <label htmlFor=""> Cash/Cheque. </label> */}
                                      <span>
                                        {previewTaxInvoiceData.modeOfPay}
                                      </span>
                                    </div>
                                    {previewTaxInvoiceData.modeOfPay ===
                                      "Cheque" && (
                                        <>
                                          <div>
                                            <label htmlFor="">
                                              Cheque No.{" "}
                                              <span>
                                                {previewTaxInvoiceData.chequeNo}
                                              </span>
                                            </label>
                                          </div>

                                          <div>
                                            <label htmlFor="">
                                              {previewTaxInvoiceData.bankName}
                                            </label>
                                          </div>
                                        </>
                                      )}
                                  </div>
                                  {previewTaxInvoiceData.modeOfTransport && (
                                    <>
                                      <div className="place-heading ">
                                        <label htmlFor="">
                                          Mode Of Transport:
                                        </label>
                                      </div>
                                      <div className="place">
                                        <label htmlFor="">
                                          {" "}
                                          {
                                            previewTaxInvoiceData.modeOfTransport
                                          }
                                        </label>
                                      </div>
                                    </>
                                  )}

                                  {previewTaxInvoiceData.modeOfTransport ===
                                    "By Road" && (
                                      <>
                                        <div className="place-heading ">
                                          <label htmlFor="">Vehicle No.</label>
                                        </div>
                                        <div className="place">
                                          <label htmlFor="">
                                            {previewTaxInvoiceData.vehicleNumber}
                                          </label>
                                        </div>
                                      </>
                                    )}

                                  {previewTaxInvoiceData?.lutBondNo && (
                                    <>
                                      <div className="place-heading ">
                                        <label htmlFor="">LUT Bond No</label>
                                      </div>
                                      <div className="place">
                                        <label htmlFor="">
                                          {previewTaxInvoiceData?.lutBondNo}
                                        </label>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="name-details-main" id="info">
                      <div className="name-details-inner  ">
                        <div className="print-table-outer">
                          <table className="" style={{ width: "100%" }}>
                            <tr>
                              <td style={{ width: "58%" }}>
                                <div className=" left p-0">
                                  <div className="name">
                                    <label htmlFor="" id="small-heading">
                                      Bill To,
                                    </label>

                                    <br />
                                  </div>
                                  <div className="address">
                                    <div>
                                      <label htmlFor="">
                                        {previewTaxInvoiceData.custName}
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" id="address">
                                        {previewTaxInvoiceData.billAddr}
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" className="contact">
                                        Email Id :
                                        <span>
                                          {" "}
                                          {previewTaxInvoiceData.billEmail}
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" className="contact">
                                        Contact No:
                                        <span>
                                          {" "}
                                          {previewTaxInvoiceData.billContactNo}
                                        </span>
                                      </label>
                                    </div>
                                    {appSettings &&
                                      appSettings.isGSTApplicable && (
                                        <div>
                                          <label htmlFor="" className="gst-no">
                                            GST:{" "}
                                            <span>
                                              {previewTaxInvoiceData.billGSTNo}{" "}
                                            </span>
                                          </label>
                                        </div>
                                      )}
                                    {previewTaxInvoiceData.billState && (
                                      <div>
                                        <label htmlFor="" className="gst-no">
                                          State :{" "}
                                          <span>
                                            {previewTaxInvoiceData.billState}{" "}
                                          </span>
                                        </label>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td>
                                {previewTaxInvoiceData?.shipCustName && (
                                  <div className=" right p-0">
                                    <div className="name">
                                      <label htmlFor="" id="small-heading">
                                        Ship To,{" "}
                                      </label>

                                      <br />
                                    </div>
                                    <div className="address">
                                      <div>
                                        <label htmlFor="">
                                          {previewTaxInvoiceData.shipCustName}
                                        </label>
                                      </div>
                                      <div>
                                        <label htmlFor="" id="address">
                                          {previewTaxInvoiceData.shipAddr}
                                        </label>
                                      </div>
                                      <div>
                                        <label htmlFor="" className="contact">
                                          Contact No:
                                          <span>
                                            {" "}
                                            {
                                              previewTaxInvoiceData.shipContactNo
                                            }
                                          </span>
                                        </label>
                                      </div>
                                      {appSettings &&
                                        appSettings.isGSTApplicable && (
                                          <div>
                                            <label
                                              htmlFor=""
                                              className="gst-no"
                                            >
                                              GST:{" "}
                                              <span>
                                                {
                                                  previewTaxInvoiceData.shipGSTNo
                                                }{" "}
                                              </span>
                                            </label>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                )}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div
                      className="detail-table-main"
                      id="modal-in-tab"
                      style={{ marginTop: "-4px" }}
                    >
                      <table
                        style={{
                          borderTop: "0.765311px solid #111111",
                          borderBottom: "0.765311px solid #111111",
                          width: "100%",
                        }}
                      >
                        <thead>
                          <tr className="heading-row">
                            <td style={{ paddingLeft: "10px" }}>#</td>
                            <td>Product Name/Service Name</td>
                            <td>HSN/SAC</td>
                            <td>Quantity</td>
                            <td>Rate</td>
                            <td>Unit</td>
                            <td>Discount</td>
                            <td
                            // style={{ width: "20%" }}
                            >
                              Amount
                            </td>
                            {appSettings &&
                              appSettings.isGSTApplicable &&
                              isStateSame ? (
                              <>
                                <td colSpan="2">CGST</td>
                                <td colSpan="2">SGST</td>
                              </>
                            ) : (
                              <>
                                {appSettings && appSettings.isGSTApplicable && (
                                  <td colSpan="2">IGST</td>
                                )}
                              </>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {previewTaxInvoiceData.invoiceDetails &&
                            previewTaxInvoiceData.invoiceDetails.length > 0 &&
                            previewTaxInvoiceData.invoiceDetails.map(
                              (invDetails, index) => {
                                let unit =
                                  units &&
                                  units.filter((item) => {
                                    return item.id === invDetails.unitId;
                                  })[0]?.unit;
                                return (
                                  <tr key={invDetails.id}>
                                    <td
                                      style={{
                                        paddingTop: "2px",
                                        paddingBottom: "2px",
                                        paddingLeft: "10px",
                                      }}
                                    >
                                      {index + 1}
                                    </td>
                                    <td style={{ padding: "2px 0" }}>
                                      {invDetails.productName}
                                    </td>
                                    <td style={{ padding: "2px 0" }}>
                                      {invDetails.hsnCode}
                                    </td>
                                    <td style={{ padding: "2px 0" }}>
                                      {invDetails.qty}
                                    </td>
                                    <td style={{ padding: "2px 0" }}>
                                      {invDetails.rate}
                                    </td>
                                    <td style={{ padding: "2px 0" }}>{unit}</td>
                                    <td style={{ padding: "2px 0" }}>
                                      {invDetails.discPer}{" "}
                                      {appSettings?.discType === "Amount"
                                        ? ""
                                        : "%"}
                                    </td>
                                    <td style={{ padding: "2px 0" }}>
                                      {invDetails.discAmount}
                                    </td>
                                    {appSettings &&
                                      appSettings.isGSTApplicable &&
                                      isStateSame ? (
                                      <>
                                        <td style={{ padding: "2px 0" }}>
                                          {invDetails.cgst}%
                                        </td>
                                        <td style={{ padding: "2px 0" }}>
                                          {invDetails.cgstAmount}
                                        </td>
                                        <td style={{ padding: "2px 0" }}>
                                          {invDetails.sgst}%
                                        </td>
                                        <td style={{ padding: "2px 0" }}>
                                          {invDetails.sgstAmount}
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        {appSettings &&
                                          appSettings.isGSTApplicable && (
                                            <td style={{ padding: "2px 0" }}>
                                              {invDetails.igst}%
                                            </td>
                                          )}
                                        {appSettings &&
                                          appSettings.isGSTApplicable && (
                                            <td style={{ padding: "2px 0" }}>
                                              {invDetails.igstAmount}
                                            </td>
                                          )}
                                      </>
                                    )}
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </table>
                    </div>

                    <div
                      className="sub-total-section"
                      style={{ marginTop: "-20px  " }}
                    >
                      <div className="bank-details">
                        {previewTaxInvoiceData?.bankDetails && (
                          <label htmlFor="">Bank Details :</label>
                        )}
                        {previewTaxInvoiceData?.bankDetails &&
                          previewTaxInvoiceData?.bankDetails
                            .split("\r\n")
                            .map((str, i) => {
                              return (
                                <div
                                  key={i + "bankDetails"}
                                  className="bank-sub"
                                >
                                  <label htmlFor="">{str && str}</label>
                                </div>
                              );
                            })}
                      </div>
                      <div className="right-section">
                        <div className="left">
                          <div className="text-sub">
                            <label htmlFor="">Sub Total</label>
                          </div>
                          {appSettings &&
                            appSettings.isGSTApplicable &&
                            isStateSame ? (
                            <>
                              <div className="text-sub">
                                <label htmlFor="">CGST</label>
                              </div>
                              <div className="text-sub">
                                <label htmlFor="">SGST</label>
                              </div>
                            </>
                          ) : (
                            <>
                              {appSettings && appSettings.isGSTApplicable && (
                                <div className="text-sub">
                                  <label htmlFor="">IGST</label>
                                </div>
                              )}
                            </>
                          )}
                          {appSettings && appSettings?.isRoundOff && (
                            <div className="text-sub">
                              <label htmlFor="">Round off</label>
                            </div>
                          )}
                        </div>
                        <div className="right">
                          <div className="sub-total">
                            <label htmlFor="">
                              ₹ {previewTaxInvoiceData.subTotal}
                            </label>
                          </div>
                          {appSettings &&
                            appSettings.isGSTApplicable &&
                            isStateSame ? (
                            <>
                              <div className="sub-total">
                                <label htmlFor="">
                                  ₹ {previewTaxInvoiceData.cgstAmount}
                                </label>
                              </div>
                              <div className="sub-total">
                                <label htmlFor="">
                                  ₹ {previewTaxInvoiceData.sgstAmount}
                                </label>
                              </div>
                            </>
                          ) : (
                            <>
                              {appSettings && appSettings.isGSTApplicable && (
                                <div className="sub-total">
                                  <label htmlFor="">
                                    ₹ {previewTaxInvoiceData.igstAmount}
                                  </label>
                                </div>
                              )}
                            </>
                          )}
                          {appSettings && appSettings?.isRoundOff && (
                            <div className="sub-total">
                              <label htmlFor="">
                                Rs.{" "}
                                {previewTaxInvoiceData.roundOff.toFixed(2) ||
                                  "0.00"}
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className="mainsub-total"
                      style={{
                        borderBottom: "0.765311px solid rgba(35, 33, 34, 0.5) ",
                      }}
                    ></div>
                    <div className="total-amt-main">
                      <div
                        className="total-amount-section"
                        id="sub-total-section"
                      >
                        <div
                          style={{
                            display: "flex",
                            marginRight: "150px",
                            alignItems: "left",
                            fontSize: "12px",
                          }}
                        >
                          <label htmlFor="">
                            {" "}
                            <b>Payments Terms : </b>
                          </label>
                          <label htmlFor="">
                            &nbsp;
                            {previewTaxInvoiceData?.paymentTerms}
                          </label>
                        </div>
                        <div className="left">
                          <div className="text-sub">
                            <label htmlFor="">Total Amount</label>
                          </div>
                        </div>
                        <div className="right">
                          <div className="sub-total">
                            <label htmlFor="">
                              ₹{" "}
                              {commaNumber(
                                Math.round(
                                  previewTaxInvoiceData.totalAmount
                                ).toFixed(2)
                              )}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="in-word">
                        <label htmlFor="">{amountInWords}</label>
                      </div>
                    </div>
                    <div
                      className="line-total"
                      style={{
                        borderBottom: "0.765311px solid #111111 ",
                        borderRadius: "3.82655px",
                      }}
                    ></div>
                    <div className="disc-sign-main ">
                      <table style={{ width: "100%" }}>
                        <tr>
                          {/* <td
                                      valign="top"
                                      style={{ paddingRight: "20px" }}
                                    >
                                      <div className=" left ">
                                        <div
                                          className="description"
                                          style={{
                                            borderRadius: "5px",
                                          }}
                                        >
                                          <textarea
                                            className="form-control"
                                            id="exampleFormControlTextarea1"
                                            rows="3"
                                            placeholder="Declaration"
                                          ></textarea>
                                        </div>
                                      </div>
                                    </td> */}

                          <td>
                            <div className="terms_service">
                              <p className="main-title">Terms of Services :</p>
                              <div className="term-conditions">
                                {company_details?.terms
                                  ? company_details.terms
                                  : ""}
                              </div>
                            </div>
                          </td>

                          {/* <td
                                      valign="top"
                                      style={{ paddingRight: "20px", width : "312px" }}
                                    >
                                      <div className="left">
                                        <div
                                          className="Terms-of-Services"
                                          style={{
                                            border: "0.765311px solid #111111 ",
                                            padding: "7px",
                                            borderRadius: "5px",
                                          }}
                                        >
                                          <div
                                            className="heading-TS"
                                            style={{ fontSize: "11px" }}
                                          >
                                            <label
                                              htmlFor=""
                                              style={{ fontWeight: "600" }}
                                            >
                                              Terms of Services :
                                            </label>
                                          </div>

                                          <div className="term-conditions">
                                            {company_details?.terms ? company_details.terms : ""}
                                          </div>

                                        </div>
                                      </div>
                                    </td> */}

                          <td valign="top">
                            <div className="right">
                              <div
                                className="upload"
                                style={{
                                  border: "0.765311px solid #111111 ",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  padding: "10px",
                                }}
                              >
                                {Dark === "lightMode" ? (
                                  <img
                                    src={
                                      company_details?.signtureLogo
                                        ? company_details?.signtureLogo
                                        : ""
                                    }
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    src={
                                      company_details?.signtureLogo
                                        ? company_details?.signtureLogo
                                        : ""
                                    }
                                    alt=""
                                  />
                                )}{" "}
                                <br />
                                <label
                                  htmlFor=""
                                  className="text-auth"
                                  style={{
                                    fontSize: "11px",
                                  }}
                                >
                                  Authorized Signature
                                </label>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={print}
        onHide={() => setPrint(false)}
        centered
        className="print-modal-box-main"
      >
        <Modal.Body>
          <div className="header-print" closeButton>
            <div className="left">
              <label htmlFor="">Print</label>
            </div>
            <div className="right">
              <img
                src={close_modal}
                alt=""
                onClick={() => setPrint(false)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          <div className="">
            <div className="option-btns">
              <input
                className="form-check-input"
                type="checkbox"
                name="flexRadioDefault"
                id="flexRadioDefault11"
                checked={typeOfPrint.length === 3 ? true : false}
                onChange={(e) =>
                  e.target.checked
                    ? setTypeOfPrint([
                      "Orginal for Buyer",
                      "Duplicate for Transporter",
                      "Triplicate for Supplier",
                    ])
                    : setTypeOfPrint([])
                }
              />

              <label className="form-check-label" for="flexRadioDefault11">
                All
              </label>
            </div>
            <div className="option-btns">
              <input
                className="form-check-input"
                type="checkbox"
                name="flexRadioDefault"
                id="flexRadioDefault22"
                checked={
                  typeOfPrint.includes("Orginal for Buyer") ? true : false
                }
                onChange={(e) => {
                  e.target.checked
                    ? setTypeOfPrint([...typeOfPrint, "Orginal for Buyer"])
                    : setTypeOfPrint(
                      typeOfPrint.filter(
                        (type) => type != "Orginal for Buyer"
                      )
                    );
                }}
              />

              <label className="form-check-label" for="flexRadioDefault22">
                Orginal for Buyer
              </label>
            </div>
            <div className="option-btns">
              <input
                className="form-check-input"
                type="checkbox"
                name="flexRadioDefault"
                id="flexRadioDefault33"
                checked={
                  typeOfPrint.includes("Duplicate for Transporter")
                    ? true
                    : false
                }
                onChange={(e) => {
                  e.target.checked
                    ? setTypeOfPrint([
                      ...typeOfPrint,
                      "Duplicate for Transporter",
                    ])
                    : setTypeOfPrint(
                      typeOfPrint.filter(
                        (type) => type != "Duplicate for Transporter"
                      )
                    );
                }}
              />

              <label className="form-check-label" for="flexRadioDefault33">
                Duplicate for Transporter{" "}
              </label>
            </div>
            <div className="option-btns">
              <input
                className="form-check-input"
                type="checkbox"
                name="flexRadioDefault"
                id="flexRadioDefault44"
                checked={
                  typeOfPrint.includes("Triplicate for Supplier") ? true : false
                }
                onChange={(e) => {
                  e.target.checked
                    ? setTypeOfPrint([
                      ...typeOfPrint,
                      "Triplicate for Supplier",
                    ])
                    : setTypeOfPrint(
                      typeOfPrint.filter(
                        (type) => type != "Triplicate for Supplier"
                      )
                    );
                }}
              />

              <label className="form-check-label" for="flexRadioDefault44">
                Triplicate for Supplier
              </label>
            </div>
          </div>
          <div className="footer-print">
            <Link
              to="#"
              className="cancelbtn text-center"
              onClick={() => {
                setPrint(false);
                setTypeOfPrint([]);
              }}
            >
              Cancel
            </Link>
            <Link
              to="#"
              className="savebtn text-center"
              onClick={() => {
                if (typeOfPrint.length === 0) {
                  notifyError("Please select type of print");
                } else {
                  setPrintModal(true);
                  setPrint(false);
                }
              }}
            >
              Print
            </Link>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ServicePrintPreview;
